var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit02 = function SvgEdit02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 20h2.262L17.498 8.764l-2.262-2.262L4 17.739zm-1.5 1.5v-4.384L16.69 2.93q.228-.207.501-.319.275-.112.575-.112t.583.107q.282.106.499.34l2.221 2.236q.233.217.332.5.099.282.099.565 0 .301-.103.576t-.328.501L6.885 21.5z"
  })));
};
export default SvgEdit02;